import styles from './PodCapacity.module.scss';

interface Props {
  count: number,
  max: number,
}

const PodCapacity = ({count, max}: Props) => {
  const countText = count > max
    ? <span className={styles.overfullCount}>{count}</span>
    : count;

          return <>{countText}&thinsp;/&thinsp;{max}</>;
}

export default PodCapacity;